<template>
  <aside class="accordion">
    <Title
      @click.native="toggleAccordion"
      :closed="!show"
    >{{ title }}</Title>
    <Content :closed="!show">{{ content }}</Content>
  </aside>
</template>

<script>
import Title from './Title'
import Content from './Content'
import { trackAccordion } from '@/utils/track'

export default {
  name: 'Accordion',
  data () {
    return {
      show: false,
      done: false,
      tracked: false
    }
  },
  props: {
    track: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  },
  components: {
    Title,
    Content
  },
  methods: {
    toggleAccordion () {
      this.show = !this.show
      if (!this.tracked) {
        trackAccordion(this.track)
      }
      this.tracked = true
    }
  }
}
</script>

<style lang="scss" scoped>
.accordion {
  border-radius: 10px;
  background-color: $c-pink;
  color: white;
  text-align: left;
}
</style>
